import MindsetsJsSDK from "../../index";
import {LoadingAction} from "../layout/actions";
import {ErrorMessageAction, InfoMessageAction, SuccessMessageAction} from "../components/CustomToast/actions";

export const LOADED_CURRICULA = '[curricula] Loaded Curricula';
export const LOADED_CURRICULA_PAGES = '[curricula] Loaded pages';
export const LOADED_CURRICULA_TOTAL = '[curricula] Loaded total';
export const LOADED_CURRICULA_CURRENT = '[curricula] Loaded current';
export const LOADED_CURRICULA_LIMIT = '[curricula] Loaded limit';
export const LOADED_CURRICULUM = '[curriculum] Loaded Curriculum';

export const LoadCurriculaAction = options => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Curricula')))
        .then(() => MindsetsJsSDK().API.get('curriculums', options))
        .then(response => {
            dispatch(LoadedCurriculaAction(response.items));
            dispatch(LoadedCurriculaCurrentAction(response.pages >= response.current ? response.current : 1));
            dispatch(LoadedCurriculaLimitAction(response.limit));
            dispatch(LoadedCurriculaPagesAction(response.pages));
            dispatch(LoadedCurriculaTotalAction(response.total));
            dispatch(LoadingAction(false));

            return response.items;
        })
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const LoadedCurriculaAction = payload => ({
    type: LOADED_CURRICULA,
    payload
});
export const LoadedCurriculaPagesAction = payload => ({
    type: LOADED_CURRICULA_PAGES,
    payload
});
export const LoadedCurriculaTotalAction = payload => ({
    type: LOADED_CURRICULA_TOTAL,
    payload
});
export const LoadedCurriculaCurrentAction = payload => ({
    type: LOADED_CURRICULA_CURRENT,
    payload
});
export const LoadedCurriculaLimitAction = payload => ({
    type: LOADED_CURRICULA_LIMIT,
    payload
});

export const SyncCurriculaAction = () => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Curricula')))
        .then(() => MindsetsJsSDK().API.patch(`curriculums`))
        .then(response => {
            response.results.map(message => dispatch(InfoMessageAction(message)));
            response.errors.map(message => dispatch(ErrorMessageAction(message)));
            if (response.results.length === 0 && response.errors.length === 0) {
                dispatch(SuccessMessageAction('Database is in sync'));
            }
        })
        .then(() => dispatch(LoadingAction(false)));
};

export const LoadCurriculumAction = (curriculum_id, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Curriculum')))
        .then(() => MindsetsJsSDK().API.get(`curriculums/${curriculum_id}`, options))
        .then(response => {
            dispatch(SetCurriculumAction(response.curriculum));
            dispatch(LoadingAction(false));

            return response.curriculum;
        })
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const LoadCurriculumByCodeAction = (curriculum_code, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Curriculum')))
        .then(() => MindsetsJsSDK().API.get(`curriculums/code/${curriculum_code}`, options))
        .then(response => dispatch(SetCurriculumAction(response.curriculum)))
        .then(() => dispatch(LoadingAction(false)))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const SetCurriculumAction = payload => ({
    type: LOADED_CURRICULUM,
    payload
});
export const CreateCurriculumAction = (data, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Creating Curriculum')))
        .then(() => MindsetsJsSDK().API.post('curriculums', data, options))
        .then(() => dispatch(LoadingAction(false)));
};
export const UpdateCurriculumAction = (curriculum_id, data, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Updating Curriculum')))
        .then(() => MindsetsJsSDK().API.put(`curriculums/${curriculum_id}`, data, options))
        .then(() => dispatch(LoadingAction(false)));
};

export const LoadCurriculumMapAction = code => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, "One moment... we're building it for you!")))
        .then(() => MindsetsJsSDK().API.get(`curriculums/${code}/map`, {buffer: true}))
        .then(response => {
            dispatch(LoadingAction(false));

            return response;
        });
};
